<canvas #flipGraph class="flip-graph" width="400" height="400"></canvas>
